module.exports = __webpack_public_path__ + "static/media/bg-services.5cd06e7d.png";